/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Query {
  /**
   * 活动id
   */
  event_id: unknown;
  /**
   * 日程id；为空表示查询活动下所有门票列表；否则查询带有该日程的门票列表
   */
  schedule_id: unknown;
}
export type TicketList = {
  /**
   * 门票组id
   */
  ticket_group_id?: number;
  /**
   * 门票Id
   */
  ticket_id?: string;
  /**
   * 门票组名称
   */
  ticket_group_name?: string;
  /**
   * 1 套票；2 场次票
   */
  ticket_group_type?: number;
  /**
   * 状态；BeforeSale:售卖尚未开始;OnSale:售卖中;AfterSale:售卖已结束;SoldOut:售罄
   */
  status?: string;
  /**
   * 库存
   */
  stock_num?: number;
  /**
   * 开始售卖时间
   */
  begin_time?: number;
  time_zone?: string;
  /**
   * 结束售卖时间
   */
  end_time?: number;
  /**
   * 门票价格
   */
  ticket_price?: number;
  /**
   * 门票组介绍
   */
  ticket_group_desc?: string;
  /**
   * 折后价（分）
   */
  discount_price?: number;
  /**
   * 百分比折扣比例，70表示7折
   */
  discount_percent?: number;
  /**
   * 包含的日程id
   */
  schedule_ids?: number[];
  /**
   * 包含日程的开始时间(如果有多个日程，取第一个)
   */
  schedule_begin?: number;
  /**
   * 包含日程的结束时间(如果有多个日程，取第最后一个)
   */
  schedule_end?: number;
  /**
   * 是否已报名当前门票
   */
  is_registed?: boolean;
  /**
   * 是否收集报名问题，0-否；1-是
   */
  is_collect_question: number;
}[];
export interface RegisterTicketListTicketRes {
  msg?: string;
  data: Data;
  code?: number;
  nonce?: string;
}
export interface Data {
  ticket_list?: TicketList;
}

const RegisterTicketListTicket = async (data: Query, ctx?: GetServerSidePropsContext) => {
  const res = await http.get<RegisterTicketListTicketRes>(
    '/wemeet-tapi',
    '/v2/activities/register/ticket/list-ticket',
    data,
    ctx,
  );

  return res;
};

export default RegisterTicketListTicket;
